import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "pocket-container"
};
const _hoisted_2 = {
  key: 1,
  class: "props-grid-list"
};
import { onMounted, ref } from 'vue';
import { ElRow } from 'element-plus';
import 'element-plus/es/components/progress/style/css';
import StagePropsCard from "@/components/Stage/StagePropsCard.vue";
import { request } from "@/manager/net_manager"; // pre-declaration

export default {
  __name: 'StagePocket',
  props: {
    stageId: {
      type: [String, Number, null],
      required: false,
      default: null
    },
    roleId: {
      type: [String, Number, null],
      required: false,
      default: null
    },
    roleName: {
      type: String,
      required: true
    }
  },
  emits: ['showPropEvent'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const data = ref([]); // functions

    const getData = () => {
      const parameters = {
        'stage_id': props.stageId,
        'role_id': props.roleId,
        'is_precis': false
      };
      request('stage/props_review/get/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          if (response.data.status === 2) {
            data.value = response.data.props;
          }
        }
      });
    };

    const showProp = item => {
      const content = `${props.roleName}展示手中道具「${item.name}」，介绍其有"${item.function_desc}"种种功效`;
      emits('showPropEvent', content);
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!data.value || data.value.length === 0 ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        class: "empty-data-tips"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createElementVNode("text", null, "未检索到审查通过的道具", -1)]))]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, key) => {
        return _openBlock(), _createBlock(StagePropsCard, {
          key: key,
          data: item,
          onClick: $event => showProp(item)
        }, null, 8, ["data", "onClick"]);
      }), 128))]))]);
    };
  }

};